// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"admin_wrapper__36ZMb","search":"admin_search__2Dns_"};